import { BaseModel } from "sjs-base-model";

export default class AppuntamentoModel extends BaseModel {
    readonly idAppointment: number = 0;
    readonly object: string = "";
    readonly text: string = "";
    readonly appointmentDate: string = "";
    readonly startTime: string = "";
    readonly endTime: string = "";
    readonly cityCode: string = "";
    readonly addressTypeCode: string = "";
    readonly address: string = "";
    readonly civicNumber: string = "";

    constructor(data: Partial<AppuntamentoModel>) {
        super();

        this.update(data);
    }
}
